<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="110"
      inline
    >
      <FormItem label="字典类别名称" prop="dicCategroyName">
        <Input class="w-250" v-model="editModel.dicCategroyName"></Input>
      </FormItem>
      <FormItem label="字典类别代码" prop="dicCategroyCode">
        <Input
          :disabled="true"
          placeholder="字典类别代码必须唯一"
          class="w-250"
          v-model="editModel.dicCategroyCode"
        ></Input>
      </FormItem>

      <h3 class="mb-4">
        字典项数据
        <a class="ml-3" @click="handlerItem('add')">添加字典项数据</a>
      </h3>
      <div class="dictionaryItems-panel">
        <Table border :columns="columns1" :data="dictionaryItems"></Table>
      </div>
    </Form>
    <div class="mb-4 ml-5 mt-5 text-center modal-foter">
      <Button class="mr-3" @click="close">取 消</Button>
      <Button
        class="mr-3"
        type="success"
        @click="updateDicCategroy('editModel')"
        >确 定</Button
      >
    </div>

    <!-- 新增\编辑字典项 -->
    <Modal
      v-model="addItemModal"
      :title="modaltitle"
      @on-ok="handlerItemSubmit"
    >
      <Form :model="DictionarySingleModel" :label-width="100" inline>
        <FormItem label="字典值">
          <Input
            class="w-250"
            v-model="DictionarySingleModel.dictionaryValue"
          ></Input>
        </FormItem>
        <FormItem label="字典代码">
          <Input
            class="w-250"
            v-model="DictionarySingleModel.dictionaryCode"
          ></Input>
        </FormItem>
        <FormItem label="排序">
          <Input
            class="w-250"
            type="number"
            v-model="DictionarySingleModel.sortNum"
          ></Input>
        </FormItem>
        <FormItem label="描述">
          <Input type="textarea" class="w-250" :rows="4" v-model="DictionarySingleModel.extend01"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  props: ["editModelTemp"],
  data: function () {
    return {
      modaltitle: "新增字典项",
      addOrUpdate: "add",
      editModel: {},
      addItemModal: false,
      DictionarySingleModel: {
        dictionaryID: "",
        dictionaryCode: "",
        dictionaryValue: "",
        dicCategroyCode: "",
        sortNum: "0",
        extend01: "",
      },
      dictionaryItems: [],
      columns1: [
        {
          title: "字典值",
          key: "dictionaryValue",
        },
        {
          title: "字典代码",
          key: "dictionaryCode",
        },
        {
          title: "排序",
          key: "sortNum",
        },
        {
          title: "描述",
          key: "extend01",
        },
        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handlerItem("update", params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.deleteItemSubmit(params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      ruleValidate: {
        dicCategroyName: [
          {
            required: true,
            message: "字典类别名称不能为空",
          },
        ],
        dicCategroyCode: [
          {
            required: true,
            message: "字典类别代码不能为空",
          },
          { type: "string", max: 4, message: "最大长度4位", trigger: "blur" },
        ],
      },
    };
  },

  created: function () {
    this.editModel = this.editModelTemp;
    this.getDictionaryListByCategroyCode();
    this.DictionarySingleModel.dicCategroyCode = this.editModel.dicCategroyCode;
  },

  methods: {
    updateSubmit(from) {},

    //获取字典项数据
    getDictionaryListByCategroyCode() {
      let categroyCode = this.editModel.dicCategroyCode;
      this.$api
        .get(
          `dictionary/getDictionaryListByCategroyCode?categroyCode=${categroyCode}`
        )
        .then((rsp) => {
          if (rsp != false) {
            this.dictionaryItems = rsp.data;
          }
        });
    },

    //添加字典项
    addDictionarySingle() {
      this.$api
        .post(`dictionary/createDictionarySingle`, this.DictionarySingleModel)
        .then((rsp) => {
          if (rsp != false) {
            this.$Message.success("添加成功");
            this.addItemModal = false;
            this.getDictionaryListByCategroyCode();
            this.resetData();
          }
        });
    },

    //删除字典项
    deleteItemSubmit(data) {
      this.$api
        .post(`dictionary/deleteDictionary?dictionaryId=${data.dictionaryID}`)
        .then((rsp) => {
          if (rsp != false) {
            this.$Message.success("删除成功");
            this.getDictionaryListByCategroyCode();
          }
        });
    },

    //更新字典项
    updateDictionarySingle() {
      this.DictionarySingleModel.sortNum = this.DictionarySingleModel.sortNum.toString();
      this.$api
        .post(`dictionary/updateDictionarySingle`, this.DictionarySingleModel)
        .then((rsp) => {
          if (rsp != false) {
            this.$Message.success("更新成功");
            this.addItemModal = false;
            this.getDictionaryListByCategroyCode();
            this.resetData();
          }
        });
    },

    //更新类别
    updateDicCategroy(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          let dicCategroyId = this.editModel.dicCategroyID;
          let dicCategroyName = this.editModel.dicCategroyName;
          let dicCategroyCode = this.editModel.dicCategroyCode;
          this.$api
            .post(
              `dictionary/updateDicCategroy?dicCategroyId=${dicCategroyId}&dicCategroyName=${dicCategroyName}&dicCategroyCode=${dicCategroyCode}`
            )
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("更新成功");
                this.getDictionaryListByCategroyCode();
                this.close();
                this.loadData();
              }
            });
        }
      });
    },

    handlerItem(type, data) {
      this.resetData();
      this.addOrUpdate = type;
      if (type == "add") {
        this.modaltitle = "新增字典项";
      }
      if (type == "update") {
        this.DictionarySingleModel.dictionaryID = data.dictionaryID;
        this.DictionarySingleModel.dictionaryCode = data.dictionaryCode;
        this.DictionarySingleModel.dictionaryValue = data.dictionaryValue;
        this.DictionarySingleModel.sortNum = data.sortNum;
        this.DictionarySingleModel.extend01 = data.extend01;
        this.modaltitle = "编辑字典项";
      }
      this.addItemModal = true;
    },

    handlerItemSubmit() {
      if (this.addOrUpdate == "add") {
        this.addDictionarySingle();
      }
      if (this.addOrUpdate == "update") {
        this.updateDictionarySingle();
      }
    },

    close() {
      this.$emit("close");
    },

    loadData() {
      this.$emit("loadData");
    },

    resetData() {
      this.DictionarySingleModel.dictionaryCode = "";
      this.DictionarySingleModel.dictionaryValue = "";
      this.DictionarySingleModel.sortNum = "0";
      this.DictionarySingleModel.extend01 = "";
    },
  },
};
</script>
<style scoped>
.w-180 {
  width: 120px;
}
.dictionaryItems-panel {
  max-height: 300 !important;
  overflow: auto;
}
</style>